export const ICONS = {
  accountOff: { default: 'accountOff', plainIcon: 'accountOff_plain' },
  accountTree: { default: 'accountTree', plainIcon: 'accountTree_plain' },
  acute: { default: 'acute', plainIcon: 'acute_plain' },
  add: { default: 'add' },
  arrowBottom: { default: 'arrowDown' },
  arrowLeft: { default: 'arrowLeft' },
  arrowMenuClose: { default: 'arrowMenuClose' },
  arrowMenuOpen: { default: 'arrowMenuOpen' },
  arrowRight: { default: 'arrowRight' },
  arrowTop: { default: 'arrowUp' },
  assignment: { default: 'assignment', plainIcon: 'assignment_plain' },
  awards: { default: 'awards', plainIcon: 'awards_plain' },
  barsUp: { default: 'barsUp' },
  bell: { default: 'bell', plainIcon: 'bell_plain' },
  bolt: { default: 'bolt', plainIcon: 'bolt_plain' },
  book: { default: 'book', plainIcon: 'book_plain' },
  bookAlt: { default: 'bookAlt', plainIcon: 'bookAlt_plain' },
  bookmark: { default: 'bookmark', plainIcon: 'bookmark_plain' },
  brick: { default: 'brick', plainIcon: 'brick_plain' },
  buildings: { default: 'building' },
  calendar: { default: 'calendar', plainIcon: 'calendar_plain' },
  campaign: { default: 'campaign', plainIcon: 'campaign_plain' },
  cancel: { default: 'closeCircle', plainIcon: 'closeCircle_plain' },
  chat: { default: 'chat', plainIcon: 'chat_plain' },
  check: { default: 'check' },
  checkCircle: { default: 'checkCircle', plainIcon: 'checkCircle_plain' },
  chevronBottom: { default: 'chevronDown' },
  chevronLeft: { default: 'chevronLeft' },
  chevronRight: { default: 'chevronRight' },
  chevronTop: { default: 'chevronUp' },
  close: { default: 'close' },
  codeNumber: { default: 'codeNumber', plainIcon: 'codeNumber_plain' },
  cogsMagic: { default: 'cogsMagic', plainIcon: 'cogsMagic_plain' },
  conversionPath: { default: 'conversationPath' },
  copy: { default: 'copy', plainIcon: 'copy_plain' },
  delete: { default: 'delete', plainIcon: 'delete_plain' },
  desktopOff: { default: 'desktopOff', plainIcon: 'desktopOff_plain' },
  dislike: { default: 'dislike', plainIcon: 'dislike_plain' },
  displaySettings: { default: 'displaySettings', plainIcon: 'displaySettings_plain' },
  distance: { default: 'distance', plainIcon: 'distance_plain' },
  doneAll: { default: 'doneAll' },
  doorOpen: { default: 'doorOpen', plainIcon: 'doorOpen_plain' },
  download: { default: 'download' },
  edit: { default: 'edit', plainIcon: 'edit_plain' },
  error: { default: 'errorCircle', plainIcon: 'errorCircle_plain' },
  extension: { default: 'extension', plainIcon: 'extension_plain' },
  eye: { default: 'eye', plainIcon: 'eye_plain' },
  eyeOff: { default: 'eyeOff', plainIcon: 'eyeOff_plain' },
  favorite: { default: 'heart', plainIcon: 'heart_plain' },
  filter: { default: 'filter', plainIcon: 'filter_plain' },
  flag: { default: 'flag', plainIcon: 'flag_plain' },
  globe: { default: 'globe' },
  hearing: { default: 'hearing' },
  help: { default: 'helpCircle', plainIcon: 'helpCircle_plain' },
  helpSimple: { default: 'helpSimple' },
  home: { default: 'home', plainIcon: 'home_plain' },
  image: { default: 'image', plainIcon: 'image_plain' },
  inboxIn: { default: 'inboxIn', plainI: 'inboxIn_plain' },
  info: { default: 'infoCircle', plainIcon: 'infoCircle_plain' },
  infoUser: { default: 'infoUser', plainIcon: 'infoUser_plain' },
  inventory: { default: 'archive', plainIcon: 'archive_plain' },
  keyOff: { default: 'keyOff', plainIcon: 'keyOff_plain' },
  language: { default: 'language' },
  leftClick: { default: 'leftClick' },
  lightBulb: { default: 'lightBulb', plainIcon: 'lightBulb_plain' },
  link: { default: 'link' },
  lock: { default: 'lock', plainIcon: 'lock_plain' },
  login: { default: 'login' },
  logout: { default: 'logout' },
  mail: { default: 'mail', plainIcon: 'mail_plain' },
  mapPin: { default: 'mapPin', plainIcon: 'mapPin_plain' },
  menu: { default: 'menu' },
  minus: { default: 'checkIndeterminate' },
  mobile: { default: 'smartphone', plainIcon: 'smartphone_plain' },
  mobileOff: { default: 'smartphoneOff', plainIcon: 'smartphoneOff_plain' },
  monitoring: { default: 'monitoring' },
  moreHoriz: { default: 'moreHoriz' },
  moreVert: { default: 'moreVert' },
  mountain: { default: 'mountain', plainIcon: 'mountain_plain' },
  newRealease: { default: 'newReleases', plainIcon: 'newReleases_plain' },
  openInFull: { default: 'openInFull' },
  openNew: { default: 'openNew' },
  pauseCircle: { default: 'pauseCircle', plainIcon: 'pauseCircle_plain' },
  percent: { default: 'percent' },
  personAdd: { default: 'personAdd', plainIcon: 'personAdd_plain' },
  play: { default: 'play', plainIcon: 'play_plain' },
  playCircle: { default: 'playCircle', plainIcon: 'playCircle_plain' },
  power: { default: 'power' },
  profileShare: { default: 'profileShare', plainIcon: 'profileShare_plain' },
  readMore: { default: 'readMore' },
  refresh: { default: 'refresh' },
  search: { default: 'search' },
  seat: { default: 'seat' },
  session: { default: 'eventDate', plainIcon: 'eventDate_plain' },
  settings: { default: 'settings', plainIcon: 'settings_plain' },
  school: { default: 'school', plainIcon: 'school_plain' },
  share: { default: 'share', plainIcon: 'share_plain' },
  shieldPerson: { default: 'shieldPerson', plainIcon: 'shieldPerson_plain' },
  signpost: { default: 'signpost', plainIcon: 'signpost_plain' },
  sort: { default: 'sort' },
  sortAsc: { default: 'sortAsc' },
  sortDesc: { default: 'sortDesc' },
  sortAz: { default: 'sortAz' },
  sortAzAsc: { default: 'sortAzAsc' },
  sortAzDesc: { default: 'sortAzDesc' },
  speed: { default: 'speed', plainIcon: 'speed_plain' },
  star: { default: 'star', plainIcon: 'star_plain' },
  stopCircle: { default: 'stopCircle', plainIcon: 'stopCircle_plain' },
  stopwatch: { default: 'stopwatch', plainIcon: 'stopwatch_plain' },
  studyLesson: { default: 'studyLesson', plainIcon: 'studyLesson_plain' },
  tablet: { default: 'tablet', plainIcon: 'tablet_plain' },
  tabletOff: { default: 'tabletOff', plainIcon: 'tabletOff_plain' },
  think: { default: 'think', plainIcon: 'think_plain' },
  thumbUp: { default: 'like', plainIcon: 'like_plain' },
  time: { default: 'time', plainIcon: 'time_plain' },
  tools: { default: 'tools' },
  trackpadInput: { default: 'trackpadInput', plainIcon: 'trackpadInput_plain' },
  trendingDown: { default: 'trendingDown' },
  trendingFlat: { default: 'trendingFlat' },
  trendingUp: { default: 'trendingUp' },
  upload: { default: 'upload' },
  userCircle: { default: 'userCircle', plainIcon: 'userCircle_plain' },
  users: { default: 'users', plainIcon: 'users_plain' },
  videoCam: { default: 'videocam', plainIcon: 'videocam_plain' },
  volumeOff: { default: 'volumeOff', plainIcon: 'volumeOff_plain' },
  volumeOn: { default: 'volumeOn', plainIcon: 'volumeOn_plain' },
  warning: { default: 'warning', plainIcon: 'warning_plain' },
};
